
function formatSecondsAsTime(sec) {
  if (sec < 60) return `${sec}с`;
  const min = Math.floor(sec / 60);
  const rem = Math.round(sec % 60);
  return `${min}:${String(rem).padStart(2, '0')}`;
}

function paceFromTarget(distance_m, sec) {
  const paceMinPerKm = (sec / 60) / (distance_m / 1000);
  const min = Math.floor(paceMinPerKm);
  const secPart = Math.round((paceMinPerKm - min) * 60);
  return `${min}:${String(secPart).padStart(2, '0')}`;
}

export function formatTargetTime(target) {
  if (!target) return '';
  return `${formatSecondsAsTime(target.time_low_sec)}-${formatSecondsAsTime(target.time_high_sec)}`;
}

export function formatTargetPace(target) {
  if (!target) return '';
  const avgSec = (target.time_low_sec + target.time_high_sec) / 2;
  return paceFromTarget(target.distance_m, avgSec);
}

export function workoutHasTargetHr(workout) {
  if (!workout) return false;
  if (workout.workout_type === 'easy' || workout.workout_type === 'long_run') return true;
  return (workout.intervals || []).some((i) => i.type === 'steady');
}